import React from 'react';
import ArticleDetailPage from './ArticleDetailPage';
import { detectionDispatchPosts, getDetectionDispatchBySlug } from '../config/detectionDispatchPosts';

const DetectionDispatchDetailPage = () => (
  <ArticleDetailPage
    posts={detectionDispatchPosts}
    getBySlug={getDetectionDispatchBySlug}
    basePath="/detection-dispatch"
    listPath="/detection-dispatch"
    listLabel="Detection Dispatch"
  />
);

export default DetectionDispatchDetailPage;
